import React, { useEffect, Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import useFoodpassionCrm from 'hooks/foodpassion-crm/useFoodpassionCrm'
import { useFpMembershipQuery } from 'graphQL/hatostore/generate/operations'
import LoadingBrand from 'components/LoadingBrand'
const Home = lazy(() => import('./Home'))

export const basePath = '/foodpassion-crm'
export enum FoodpassionPath {
  Home = '/',
}
const FoodpassionRouter = () => {
  const { initFoodpassionCrmState, handleSetLoadingMembership } = useFoodpassionCrm()

  useFpMembershipQuery({
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted: async ({ fpMembership }) => await initFoodpassionCrmState(fpMembership),
    onError: () => handleSetLoadingMembership(false),
  })

  useEffect(() => {
    document.title = 'Gon Gang Member'
  }, [])

  return (
    <Suspense fallback={<LoadingBrand show={true} />}>
      <Routes>
        <Route path={FoodpassionPath.Home} element={<Home />} />
      </Routes>
    </Suspense>
  )
}

export default FoodpassionRouter
